import { Component, Input, OnInit, SimpleChanges } from '@angular/core';
import * as moment from 'moment';
import { SitesService } from 'src/app/sites/sites.service';

@Component({
	selector: 'app-battery-report',
	templateUrl: './battery-report.component.html',
	styleUrls: ['./battery-report.component.css']
})
export class BatteryReportComponent implements OnInit{

	constructor(private siteService: SitesService) {}
	@Input() device: any;
	@Input() allDailyDetails: any;
	@Input() utilizationScoreData: any;
	@Input() currentSite: any;
	@Input() printReportSummeryPeriodInfo: { from: number, to: number, period: string } = { from: 0, to: 0, period: '' };

	tempData = [];
	socData = [];
	tempChartOptions: any = {};
	socChartOptions: any = {};
	toDayDate: string;

	period = {
		from: null,
		to: null
	};

	tempColumns = [
		{ type: 'date', label: 'Week' },
		'Temperature',
		{ role: 'style' },
		{ role: 'tooltip', type: 'string', p: { html: true } }
	];

	socColumns = [
		{ type: 'date', label: 'Week' },
		'SOC',
		{ role: 'style' },
		{ role: 'tooltip', type: 'string', p: { html: true } }
	];

	ngOnInit(): void {

	}

	ngOnChanges(changes: SimpleChanges) {
		if (changes['allDailyDetails'] && this.allDailyDetails) {
			this.formatData();
			this.toDayDate = moment().format('MM/DD/YYYY');

			this.period = {
				from: moment(this.printReportSummeryPeriodInfo.from * 1000).utc().startOf('day').format('MM/DD/YYYY'),
				to: moment(this.printReportSummeryPeriodInfo.to * 1000).utc().endOf('day').format('MM/DD/YYYY'),
			}
		}
	}

	formatData() {
		this.tempData = this.allDailyDetails?.heatMaps?.temperature.map(t => [
			this.toLocalDate(t.label),
			1,
			this.tempColorByRange(t.range),
			`Temperature: <strong>${t.value}°F</strong>`
		]);

		this.socData = this.allDailyDetails?.heatMaps?.soc.map(s => [
			this.toLocalDate(s.label),
			1,
			s.status === 'low' ? 'color: #ff5252' : 'color: #9af59a',
			`SOC: <strong>${s.value}%</strong>`
		]);

		this.tempChartOptions = this.buildChartOptions(this.tempData);
		this.socChartOptions = this.buildChartOptions(this.socData);
	}

	private buildChartOptions(data: any[]): any {
		const baseOptions: any = {
			legend: 'none',
			bar: { groupWidth: '100%' },
			vAxis: {
				minValue: 0,
				textPosition: 'none',
				gridlines: { color: 'transparent' }
			},
			tooltip: { isHtml: true },
		};

		if (data?.length) {
			const lastDate: Date = data[data.length - 1][0];
			baseOptions.hAxis = {
				viewWindow: { max: lastDate }
			};
		}

		return baseOptions;
	}

	private toLocalDate(label: string): Date {
		const d = new Date(label);
		return new Date(d.getUTCFullYear(), d.getUTCMonth(), d.getUTCDate());
	}

	tempColorByRange(range: string): string {
		switch (range) {
			case 'low': return 'color: #8fd3f4';
			case 'normal': return 'color: #C4A484';
			case 'warm': return 'color: #ffe082';
			case 'hot': return 'color: #e53935';
			default: return 'color: #cfd8dc';
		}
	}


	clampPercent(value?: string): string {
		if (!value) 
			return '0%';

		const num = parseFloat(value);
		return `${Math.min(num, 100)}%`;
	}


	getVoltagePercent(type: 'high' | 'mid' | 'low'): string {
		const total = this.allDailyDetails.endVoltage.high + this.allDailyDetails.endVoltage.mid + this.allDailyDetails.endVoltage.low;
		if (total === 0) 
			return '0%';
		return Math.round((this.allDailyDetails.endVoltage[type] / total) * 100) + '%';
	}

	getDailyHoursGradient() {
		const inUse = parseFloat(this.allDailyDetails.dailyHours?.inUse?.percent);
		const charge = parseFloat(this.allDailyDetails.dailyHours?.charge?.percent);
		return `conic-gradient(#3498db 0% ${inUse}%, #27ae60 ${inUse}% ${inUse + charge}%, #95a5a6 ${inUse + charge}% 100%)`;
	}

	getAhrGradient() {
		const inUse = parseFloat(this.allDailyDetails.dailyAhr?.inUse?.percent);
		const charge = parseFloat(this.allDailyDetails.dailyAhr?.charge?.percent);
		return `conic-gradient(#3498db 0% ${inUse}%, #27ae60 ${inUse}% ${inUse + charge}%, #eeeeee ${inUse + charge}% 100%)`;
	}

	getVoltageWidth(val: number): string {
		const total = this.allDailyDetails.endVoltage.high + this.allDailyDetails.endVoltage.mid + this.allDailyDetails.endVoltage.low;
		return total > 0 ? (val / total * 100) + '%' : '0%';
	}
}
